import React from 'react'
import PropTypes from 'prop-types'
import {Box, HStack, useMultiStyleConfig} from '@chakra-ui/react'
import DisplayPrice from '../display-price'
import {InfoIcon} from '../icons'
import InfoPopover from '../popovers/info-popover'
import OmnibusPrice from '../display-price/omnibus-price'
import VatLabel from '../vat-label'
import WeeeFee from '../weee-fee'
import {useBooleanCustomPreference} from '../../hooks/use-custom-preference'
import {useIntl} from 'react-intl'

const PriceCard = ({priceData, product, activeCurrency, variant = ''}) => {
    const intl = useIntl()
    const styles = useMultiStyleConfig('PriceCard', {variant})
    const weeeFee = product?.c_weeeFee || 0
    const isVATFlag = useBooleanCustomPreference('showVATFlag')
    const notShoppableCountry = useBooleanCustomPreference('notShoppableCountry')

    const {isOnSale} = priceData || false
    return (
        <Box {...styles.container}>
            {!notShoppableCountry && (
                <HStack {...styles.priceBoxIva}>
                    <Box {...styles.priceBox}>
                        {priceData?.currentPrice ? (
                            <DisplayPrice
                                priceData={priceData}
                                currency={product?.currency || activeCurrency}
                                productDetailPriceView={true}
                                showDiscount={true}
                                variant={variant}
                            />
                        ) : (
                            <></>
                        )}
                        {isOnSale ? (
                            <InfoPopover
                                trigger={
                                    <Box>
                                        <InfoIcon {...styles.infoIcon} />
                                    </Box>
                                }
                                variant="top-left-no-y-offset"
                                openTooltipOn="hover"
                                title={intl.formatMessage({
                                    id: 'price_card.info.popover.title',
                                    defaultMessage: 'PriceCard Popover Title',
                                })}
                                description={intl.formatMessage({
                                    id: 'price_card.info.popover.description',
                                    defaultMessage: 'PriceCard Popover Description',
                                })}
                            />
                        ) : (
                            <></>
                        )}
                    </Box>

                    {isVATFlag && priceData ? <VatLabel /> : <></>}
                    {weeeFee ? <WeeeFee price={weeeFee} /> : <></>}
                    <OmnibusPrice
                        priceData={priceData}
                        currency={product?.currency || activeCurrency}
                        omnibusExpandedView={true}
                        showDiscount={true}
                    />
                </HStack>
            )}
        </Box>
    )
}

PriceCard.propTypes = {
    priceData: PropTypes.shape({
        currentPrice: PropTypes.number,
        isOnSale: PropTypes.bool,
    }).isRequired,
    product: PropTypes.shape({
        currency: PropTypes.string,
        c_weeeFee: PropTypes.number,
    }),
    activeCurrency: PropTypes.string.isRequired,
    variant: PropTypes.string,
}
export default PriceCard
